import { InputAdornment, TextField, MenuItem, IconButton } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { OurDearStateUrl } from '../../common/url'
import axios from 'axios'
import ClearIcon from '@mui/icons-material/Clear'
import { Image } from 'antd'
import LocationStateIcon from '../../assets/our-dealer/our-dealer-location-state.png'

export type SMAppClearProps = {
    clearAction?: () => void
    onChange?: (text: string) => void
}

export const AppStateSelect: React.FC<SMAppClearProps> = (props) => {
    // ======================= PROPS
    const { clearAction, onChange } = props

    const [value, setValue] = useState('State')
    const [data, setData] = useState([])
    const [originalData, setOriginalData] = useState([])

    const handleChange = (item: string, index: number) => {
        setValue(item)
        onChange(item)
        console.log('选中的数据===' + JSON.stringify(originalData[index]))
    }

    const clearTextAction = () => {
        setValue('')
        clearAction()
    }

    const renderItem = (index: number) => {
        return (
            <MenuItem key={index} disabled={index === 0 ? true : false} value={data[index]} onClick={() => handleChange(data[index], index)}>
                {data[index]}
            </MenuItem>
        )
    }

    const fetchList = async () => {
        try {
            const response = await axios.get(OurDearStateUrl)
            // setData(response.data['data'])
            console.log('state接口数据===' + JSON.stringify(response.data['data']))
            setOriginalData(response.data['data'])
            var list = ['State']
            var resData = response.data['data']
            for (var i = 0; i < resData.length; i++) {
                var map = resData[i]
                list = [...list, map['attributes']['stateName']]
            }
            setData(list)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        ; (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <TextField
            fullWidth
            select
            value={value}
            InputProps={{
                style: {
                    borderRadius: '10px',
                },
                startAdornment: (
                    <InputAdornment position='start'>
                        <Image src={LocationStateIcon} width={20} height={20} alt='' preview={false}></Image>
                    </InputAdornment>
                ),
                endAdornment: (
                    value === null || value === '' || value === 'State' ? (<></>) : <IconButton
                        sx={{ marginRight: '16px' }}
                        onClick={() => clearTextAction()}
                    >
                        <ClearIcon sx={{ width: 18, height: 18 }} />
                    </IconButton>
                ),
            }}

            sx={{
                width: '100%',
                paddingBlockEnd: '12px',
                '& .MuiOutlinedInput-root.Mui-focused': {
                    '& > fieldset': {
                        borderColor: '#E4E7ED',
                    },
                },
                '& .MuiOutlinedInput-root:hover': {
                    '& > fieldset': {
                        borderColor: '#E4E7ED',
                    },
                },
            }}
        >
            {
                data.map((item, index) => (
                    renderItem(index)
                ))
            }
        </TextField>
    )
}

export default AppStateSelect
